import React, {useState, useContext, useEffect, Fragment} from 'react';
import "../styles/registerClinician.css";
import clinicianModel from "../model/clinician_model";
import {IonButton, IonCardContent, IonTitle} from "@ionic/react";
import {handleRegisterUser, getFilteredUsers, getAllSites} from "../service/adminUI";
import registerUserModel from "../model/registerUserModel";
import AppContext from "./AppContext";
import {displayError, getPattern, hideError, mapFormDataWithModel} from "../util/dynamicForm";
import * as _ from "lodash";
import { updateUserModel } from '../model/registerUserModel';
import SessionManager from '../service/SessionManager';
import { sendNotificationEmail } from '../service/notificationService';


let uniqueKey = 'email';
let userid = '';

const RegisterClinician = props => {
    const {bckimgChange, setRegisterToast} = props;
    const TOAST_ERROR_CSS = 'toast toast-error';
    const TOAST_SUCCESS_CSS = 'toast toast-success';
    const {appData, pageData, setPageData} = useContext(AppContext);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [clinicianVal, setClinicianVal] = useState([]);
    const [registerRequest, setRegisterRequest] = useState(false);
    const [cancelRequest, setCancelRequest] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [registerLabel, setRegisterLabel] = useState("Register");
    const [siteOptions, setSiteOptions] = useState([]);
    const [selectedSites, setSelectedSites] = useState([]);
    let clinician = [];

    useEffect(() => {
        bckimgChange('registerClinician.png');
        setClinicianVal(clinician);
        (async () => {
            try {
                const sites = await getAllSites(SessionManager.getAccessToken());
                setSiteOptions(sites || []);
            } catch (err) {
                console.warn('Failed to load sites:', err);
            }
        })();
    }, [])

    useEffect(() => {
        if (registerRequest) {
            handleRegisterClinicianRequest();            
        }
        if (cancelRequest) {
            clearForm();
            setCancelRequest(false)
        }
    }, [registerRequest, cancelRequest]);

    const handleEyeIconOnClick = () => {
        setPasswordVisible(!passwordVisible);
    };

    const handleRegisterClinicianRequest = async () => {
        const toastParams = await handleRegisterClinicianOnClick();
        if (toastParams) {
            setRegisterToast(toastParams);
        }
        setCancelRequest(false)
    }
    
    const handlerCancelFormOnClick = () => {
        setCancelRequest(true);
    }

    const handleRegisterOnClick = () => {
        setRegisterRequest(true);
    }

    const validateClinicianData = () => {
        let validationResult = true;
        const clinicianData = [...clinicianVal];
        for (let i = 0; i < clinicianData.length; i++) {
            if (clinicianData[i].pattern === "password") {
                if (clinicianData[i].value) {
                    clinicianData[i].isValid = true;
                    hideError(clinicianData[i].key);
                } else {
                    clinicianData[i].isValid = false;
                    validationResult = false;
                    displayError(clinicianData[i].key);
                }
            } else if (clinicianData[i].pattern === "array" || Array.isArray(clinicianData[i].value)) {
                if (clinicianData[i].value && clinicianData[i].value.length > 0) {
                    clinicianData[i].isValid = true;
                    hideError(clinicianData[i].key);
                } else {
                    clinicianData[i].isValid = false;
                    validationResult = false;
                    displayError(clinicianData[i].key);
                }
            } else if (clinicianData[i].pattern === 'default') {
                if (clinicianData[i].value) {
                    clinicianData[i].isValid = true;
                    hideError(clinicianData[i].key);
                } else {
                    clinicianData[i].isValid = false;
                    validationResult = false;
                    displayError(clinicianData[i].key);
                }
            } else {
                if (clinicianData[i].value && clinicianData[i].value.match(clinicianData[i].pattern)) {
                    clinicianData[i].isValid = true;
                    hideError(clinicianData[i].key);
                } else {
                    clinicianData[i].isValid = false;
                    validationResult = false;
                    displayError(clinicianData[i].key);
                }
            }
        }
        setClinicianVal(clinicianData);
        return validationResult;
    }

    const validateExistingClinicianData = () => {
        let validationResult = true;
        const clinicianData = [...clinicianVal];
        for (let i = 0; i < clinicianData.length; i++) {
            //iterate through inputs that are set
            if (clinicianData[i].value !== '') {
                // FIX(TC-WEB-ADMIN-003): handle password pattern — accept any
                // non-empty value (same logic as validateClinicianData).
                if (clinicianData[i].pattern === "password") {
                    clinicianData[i].isValid = true;
                    hideError(clinicianData[i].key);
                } else if (clinicianData[i].pattern === "array" || Array.isArray(clinicianData[i].value)) {
                    if (clinicianData[i].value && clinicianData[i].value.length > 0) {
                        clinicianData[i].isValid = true;
                        hideError(clinicianData[i].key);
                    } else {
                        clinicianData[i].isValid = false;
                        validationResult = false;
                        displayError(clinicianData[i].key);
                    }
                } else {
                    if (clinicianData[i].value && clinicianData[i].value.match(clinicianData[i].pattern)) {
                        clinicianData[i].isValid = true;
                        hideError(clinicianData[i].key);
                    } else {
                        clinicianData[i].isValid = false;
                        validationResult = false;
                        displayError(clinicianData[i].key);
                    }
                }
            }
        }
        setClinicianVal(clinicianData);
        return validationResult;
    }

//register clinician
    const handleRegisterClinicianOnClick = async () => {
        userid = '';
        let auniqueObj = _.filter(clinicianVal, function (o) { return o.key === uniqueKey });
        let uniqueObj = !_.isEmpty(auniqueObj) ? auniqueObj[0] : null;
        if (!_.isEmpty(uniqueObj) && uniqueObj?.value !== '' && uniqueObj.value.match(uniqueObj?.pattern)) {
            //fetch the entity
            let entityVal = await getFilteredUsers(SessionManager.getAccessToken(), uniqueObj?.value);
            if (!_.isEmpty(entityVal) && entityVal[0]?.attributes && entityVal[0]?.attributes.type && entityVal[0]?.attributes.type[0] === 'clinician') {
                userid = entityVal[0].id;
            }
        }


        if (!selectedSites.length) {
            return { css: TOAST_ERROR_CSS, message: "Please select at least one Site" };
        }

        if (userid !== '') {
            // FIX(TC-WEB-ADMIN-003): use validateExistingClinicianData for updates —
            // password is not returned by Keycloak on lookup, so it should be
            // optional when updating an existing clinician.
            if (validateExistingClinicianData()) {
                const finalModel = mapFormDataWithModel(updateUserModel, clinicianVal, 'clinician');
                finalModel.attributes.sites = selectedSites;
                const result = await handleRegisterUser(finalModel.attributes.type, finalModel, SessionManager.getAccessToken(), userid);
                if (result === true) {
                    clearForm();
                    return { css: TOAST_SUCCESS_CSS, message: "Clinician registration succeeded!" };
                } else {
                    return { css: TOAST_ERROR_CSS, message: "Error: " + result };
                }

            }
        } else {
            if (validateClinicianData()) {
                const finalModel = mapFormDataWithModel(registerUserModel, clinicianVal, 'clinician');
                finalModel.attributes.sites = selectedSites;
                const result = await handleRegisterUser(finalModel.attributes.type, finalModel, SessionManager.getAccessToken());
                if (result === true) {
                    sendNotificationEmail({
                        type: 'user_registered',
                        to: finalModel.email,
                        payload: {
                            fullName: [finalModel.firstName, finalModel.lastName].filter(Boolean).join(' '),
                            role: 'clinician',
                        },
                    });
                    clearForm();
                    return { css: TOAST_SUCCESS_CSS, message: "Clinician registration succeeded!" };
                } else {
                    return { css: TOAST_ERROR_CSS, message: "Error: " + result };
                }

            }
        }
    }

    const handleOnInput = async (event) => {
        let value = event.target.value;
        const name = event.target.name;
        const clinicianData = [...clinicianVal];
        for (let i = 0; i < clinicianData.length; i++) {
            if (clinicianData[i].key === name) {
                if (clinicianData[i].pattern === 'array') {
                    value = value.split('\n');
                }
                clinicianData[i].value = value;
            }
        }

        if (name === uniqueKey && value !== '') {
            let auniqueObj = _.filter(clinicianData, function (o) { return o.key === uniqueKey });
            let uniqueObj = !_.isEmpty(auniqueObj) ? auniqueObj[0] : null;
            if (!_.isEmpty(uniqueObj) && uniqueObj?.value !== '' && uniqueObj.value.match(uniqueObj?.pattern)) {
                //fetch the entity
                let entityVal = await getFilteredUsers(SessionManager.getAccessToken(), uniqueObj?.value);
                if (!_.isEmpty(entityVal) && entityVal[0]?.attributes && entityVal[0]?.attributes.type && entityVal[0]?.attributes.type[0] === 'clinician') {
                    setRegisterLabel("Update");
                    setRegisterToast({css: TOAST_SUCCESS_CSS,message: "Found a Clinician with email " + uniqueObj.value })
                    let username = { firstName: '0', lastName: '0', email: '0' };
                    for (var element in username) {
                        let idx = _.findIndex(clinicianData, function (o) { return o.key === element; });
                        if (idx !== -1) {
                            clinicianData[idx].value = entityVal[0][element];
                        }
                    }
                    element = 'phone';
                    let idx = _.findIndex(clinicianData, function (o) { return o.key === element; });
                    if (idx !== -1) {
                        clinicianData[idx].value = entityVal[0].attributes[element][0];
                    }
                    element = 'address'
                    idx = _.findIndex(clinicianData, function (o) { return o.key === 'address'; });
                    if (idx !== -1) {
                        clinicianData[idx].value = entityVal[0].attributes[element];
                    }
                    element = 'speciality'
                    idx = _.findIndex(clinicianData, function (o) { return o.key === element; });
                    if (idx !== -1) {
                        clinicianData[idx].value = entityVal[0].attributes[element];
                    }
                    element = 'hospital'
                    idx = _.findIndex(clinicianData, function (o) { return o.key === element; });
                    if (idx !== -1) {
                        clinicianData[idx].value = entityVal[0].attributes[element];
                    }
                    // Pre-populate site dropdown from existing user attributes
                    const existingSites = entityVal[0].attributes?.sites;
                    if (existingSites && existingSites.length > 0) {
                        setSelectedSites(Array.isArray(existingSites) ? [...existingSites] : [existingSites]);
                    }
                }else {
                    setRegisterLabel("Register");
                }

            }




        }
        setClinicianVal(clinicianData);
    };

    const clearForm = () => {
        document.getElementById('clinician-form').reset();
        document.getElementsByTagName('textarea')[0].value = '';
        setClinicianVal(clinician);
        setSelectedSites([]);
        for(let val in clinicianVal) {
            hideError(clinicianVal[val].key);
        }
    }

    return (
        <Fragment>
            <IonTitle className="clinician-title">Clinician Form
            <span
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
            className="info-icon"
          >
            &#128712;
          </span>
          {isVisible && (
            <div className="tooltip">
              Form to Register new Clinician. To update existing clinician
              information, enter email of the clinician to be updated. 
            </div>
          )}
            </IonTitle>
            <IonCardContent className="clinician-content">
                <form id="clinician-form" className="clinician-form">
                    {Object.entries(clinicianModel).map((data) => {
                        let idx = _.findIndex(clinicianVal, function(o) { return o.key === data[0]; });
                        return (
                            getPattern(data[0], data[1], 1, handleOnInput, clinician, passwordVisible, handleEyeIconOnClick,idx !== -1? clinicianVal[idx].value:clinicianVal)
                        );
                    })}
                    <div style={{ marginLeft: '1rem', marginTop: '10px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        <label style={{ fontFamily: 'PoppinsRegular', fontSize: '14px', minWidth: '100px' }}>Site :</label>
                        {selectedSites.map(id => {
                            const s = siteOptions.find(o => o.attributes?.siteId === id);
                            const label = s?.attributes?.name || `Site ${id}`;
                            return (
                                <span
                                    key={id}
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        padding: '4px 10px',
                                        background: '#25BDBD',
                                        color: '#fff',
                                        borderRadius: '16px',
                                        fontFamily: 'PoppinsRegular',
                                        fontSize: '13px',
                                    }}
                                >
                                    {label}
                                    <span
                                        role="button"
                                        aria-label={`Remove ${label}`}
                                        tabIndex={0}
                                        onClick={() => setSelectedSites(prev => prev.filter(x => x !== id))}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                setSelectedSites(prev => prev.filter(x => x !== id));
                                            }
                                        }}
                                        style={{ cursor: 'pointer', fontWeight: 'bold', lineHeight: 1 }}
                                    >
                                        ×
                                    </span>
                                </span>
                            );
                        })}
                        <select
                            value=""
                            onChange={e => {
                                const v = e.target.value;
                                if (v && !selectedSites.includes(v)) {
                                    setSelectedSites(prev => [...prev, v]);
                                }
                            }}
                            style={{ flex: 1, minWidth: '160px', padding: '8px', fontFamily: 'PoppinsRegular', fontSize: '14px' }}
                        >
                            <option value="">
                                {selectedSites.length ? 'Add another site' : 'Select Site'}
                            </option>
                            {siteOptions.map(s => {
                                const id = s.attributes?.siteId;
                                const isPicked = selectedSites.includes(id);
                                return (
                                    <option
                                        key={id}
                                        value={id}
                                        disabled={isPicked}
                                        style={isPicked ? { color: '#999' } : undefined}
                                    >
                                        {s.attributes?.name || `Site ${id}`}{isPicked ? ' (added)' : ''}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </form>
            </IonCardContent>
            <div className='homeMainFooter'>
                    <IonButton
                        class='loginButton'
                        fill='solid'
                        shape='round'
                        onClick={handlerCancelFormOnClick}>
                        Cancel
                    </IonButton>
                    <IonButton
                        class='loginButton'
                        fill='solid'
                        shape='round'
                        onClick={handleRegisterOnClick}>
                        {registerLabel}
                    </IonButton>
                </div>
        </Fragment>
    );
};
export default RegisterClinician;